import styles from "./status.module.scss";
import { DevelopmentAPI } from "pages/workspace/process/development/development.service";
import { KoDropdown, KoText, KoToast } from "packages";
import KoIcon from "@kwapio/icons";

function TaskStatus(props) {
  const { data, row, refreshData, isEpic } = props;

  const workflowList = row?.workflow || [];
  const issueType = workflowList?.find((o) => o.value === data) || {};

  const workflow = workflowList.filter(
    (item) => item.value !== issueType.value
  );

  const updateFields = (payload) => {
    DevelopmentAPI.updateTicketPatch(
      payload,
      row?.ticketId || row?.epicId,
      row?.workspace,
      isEpic
    ).then(() => {
      KoToast.success("Status updated successfully");
      refreshData?.();
    });
  };

  const statusItems = workflow.map((sta) => ({
    key: sta.value,
    label: (
      <div
        className={styles.filterList}
        onClick={() => updateFields({ status: sta.value })}
      >
        <div className={styles.userDpWithName}>
          <div
            className={styles.statusCircle}
            style={{ borderColor: sta.color }}
          />
          <KoText text={sta.label} />
        </div>
      </div>
    )
  }));

  return (
    <div className={styles.wrapper}>
      <KoDropdown
        placement="bottomRight"
        overlayClassName="overlayClassName"
        menu={{ items: statusItems }}
      >
        <div className={styles.status}>
          <div
            className={styles.circle}
            style={{ borderColor: issueType?.color }}
          />
          <div className={styles.text}>
            {issueType?.label || "-"}
          </div>
          <KoIcon name="DownArrowOutlined" height={8} width={8} />
        </div>
      </KoDropdown>
    </div>
  );
}

export default TaskStatus;
